import {Button, InputGroup, Modal} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React, {useEffect, useState} from "react";
import UserService from "../service/user.service";

export default function ModalComment({addComment, id, setAddComment, getComments}) {
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [commentName, setCommentName] = useState('')
    const [commentText, setCommentText] = useState('')
    const [commValidMsg, setCommValidMsg] = useState('')
    useEffect(() => {

    }, [addComment, id]);
    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
        setSelectedTime(''); // Сброс времени при изменении даты
    };

    const handleTimeChange = (event) => {
        setSelectedTime(event.target.value);
    };

    function createComment() {
        let validErr = ""
        if (selectedDate.length === 0) {
            validErr = validErr + "Заполни дату\n"
        }
        if (selectedTime.length === 0) {
            validErr = validErr + "Заполни время\n"
        }
        if (commentName.length === 0) {
            validErr = validErr + "Заполни имя\n"
        }
        if (commentText.length === 0) {
            validErr = validErr + "Заполни комментарий\n"
        }
        if (validErr.length === 0) {
            const data = {
                date: selectedDate + " " + selectedTime,
                name: commentName,
                text: commentText,
                model_id: id
            }
            UserService.createComment(data).then(response => {
                if (response.data) {
                    setAddComment(false)
                    getComments()
                } else {
                    setCommValidMsg("Ошибка при создании комментария!")
                }
            })
        } else {
            setCommValidMsg(validErr)
        }
    }
    const handleClose = () => setAddComment(false);

    return (
        <Modal
            show={addComment}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Header closeButton style={{backgroundColor: "#181A26"}}>
                <Modal.Title>Создание комментария</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{backgroundColor: "#181A26"}}>
                <div style={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
                    {commValidMsg.split("\n").map(msg => (
                        <span style={{color: "red", fontWeight: "bold"}}>{msg}</span>
                    ))}
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        justifyContent: "space-between",
                        width: "100%",
                        margin: "20px 0"
                    }}>
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            className="datetimepicker-input"
                        />
                        <input
                            type="time"
                            value={selectedTime}
                            onChange={handleTimeChange}
                            className="datetimepicker-input"
                        />
                    </div>
                    <InputGroup size="sm" className="mb-3">
                        <InputGroup.Text>Имя</InputGroup.Text>
                        <Form.Control value={commentName} onChange={e => setCommentName(e.target.value)}/>
                    </InputGroup>
                    <InputGroup size="sm" className="mb-3">
                        <InputGroup.Text>Комментарий</InputGroup.Text>
                        <Form.Control value={commentText} onChange={e => setCommentText(e.target.value)}/>
                    </InputGroup>
                </div>
                <div style={{display: "flex", justifyContent: "center"}}>
                    <Button className="main-btn" style={{padding: "5px 25px", fontSize: "16px", marginTop: "15px"}}
                            onClick={createComment}>Создать</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}